import { render } from "./HeadingBookmarks.vue?vue&type=template&id=1841ee94"
import script from "./HeadingBookmarks.vue?vue&type=script&lang=js"
export * from "./HeadingBookmarks.vue?vue&type=script&lang=js"

import "./HeadingBookmarks.vue?vue&type=style&index=0&id=1841ee94&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__